import * as Actions from '../actions';

const initialState = {
    majorList: [],
    currentMajor: {
        major_id: 0,
        assetList: [],
        newMajorAssets: [],
        CreateAuthID: 0,
        LastEditAuthID: 0,
        CreationDate: '',
        LastEditDate: ''
    },
    editInfo: {
        CreationDate: '',
        LastEditDate: '',
        CreateAuthEmail: '',
        EditAuthEmail: ''
    },
    isMajorLoaded: false,
    allCourses: [],
    allCompanies: [],
    currentMajorCourseList: [],
    currentMajorCompanyList: []
}

const majorReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_MAJOR_LOADED):
            {
                if (action.payload) {
                    return {
                        ...state,
                        isMajorLoaded: action.payload,
                    }
                } else {
                    // reset to default state
                    return {
                        ...initialState
                    }
                }
            }

        case (Actions.GET_MAJOR):
            {
                return {
                    ...state,
                    currentMajor: {
                        ...state.currentMajor,
                        ...action.payload,
                        major_loaded: true
                    }
                };
            }

        case (Actions.GET_MAJOR_ASSET_LIST):
            {
                const m_id = state.currentMajor.major_id;

                if (m_id === 0) {
                    const newAssetList = state.currentMajor.newMajorAssets.concat(action.payload.assetInsertResponse);
                    const new_asset_ids = newAssetList.map(m => m.insert_id);
                    const filtered_assets = action.payload.responseData.filter(m => new_asset_ids.includes(m.header.asset_id));

                    return {
                        ...state,
                        currentMajor: {
                            ...state.currentMajor,
                            assetList: filtered_assets,
                            newMajorAssets: state.currentMajor.newMajorAssets.concat(action.payload.assetInsertResponse)
                        }
                    }
                }
                else {
                    return {
                        ...state,
                        currentMajor: {
                            ...state.currentMajor,
                            assetList: action.payload.responseData,
                            newMajorAssets: []
                        }
                    }
                }

            }

        case (Actions.UPDATE_MAJOR_FORM):
            {
                return {
                    ...state,
                    currentMajor: { ...state.currentMajor, ...action.payload }
                }
            }

        case (Actions.DELETE_MAJOR):
            {
                return {
                    ...state,
                    currentMajor: { major_loaded: false },
                    majorList: state.majorList.filter((major) => major.major_id !== action.payload) // Removes Corresponding Major in MajorList
                };
            }

        case (Actions.GET_MAJOR_LIST):
            {
                return {
                    ...state,
                    majorList: action.payload
                };
            }
        case (Actions.GET_ALL_COURSES):
            {
                return {
                    ...state,
                    allCourses: action.payload.courseList
                }
            }
        case (Actions.GET_ALL_COMPANIES):
            {
                return {
                    ...state,
                    allCompanies: action.payload
                }
            }

        case (Actions.GET_RELATED_DATA):
            {
                return {
                    ...state,
                    currentMajorCourseList: action.payload.courses,
                    currentMajorCompanyList: action.payload.companies,
                    editInfo: action.payload.edit_info
                }
            }

        case (Actions.TOGGLE_COURSE):
            {
                if (action.payload.action_type === 'ADD') {
                    let newCourse = state.allCourses.filter((course) => course.course_id === action.payload.course.id)
                    return {
                        ...state,
                        currentMajorCourseList: state.currentMajorCourseList.concat(newCourse)
                    }
                }
                else {
                    return {
                        ...state,
                        currentMajorCourseList: state.currentMajorCourseList.filter((course) => course.course_id !== action.payload.course.id)
                    }
                }
            }

        case (Actions.TOGGLE_COMPANY):
            {
                if (action.payload.action_type === 'ADD') {
                    let newCompany = state.allCompanies.filter((company) => company.company_id === action.payload.company.id)
                    return {
                        ...state,
                        currentMajorCompanyList: state.currentMajorCompanyList.concat(newCompany)
                    }
                }
                else {
                    return {
                        ...state,
                        currentMajorCompanyList: state.currentMajorCompanyList.filter((company) => company.company_id !== action.payload.company.id)
                    }
                }
            }

        case (Actions.UPDATE_ASSET_NAME):
            {
                return {
                    ...state,
                    currentMajor: {
                        ...state.currentMajor,
                        assetList: state.currentMajor.assetList.map(asset => {
                            if (asset.header.asset_id === action.payload.asset_id) {
                                return {
                                    ...asset,
                                    header: {
                                        ...asset.header,
                                        AssetNewName: action.payload.newName,
                                        UneditedNewName: action.payload.saved ? action.payload.newName : asset.header.UneditedNewName
                                    }
                                }
                            }
                            return asset
                        })
                    }
                }
            }
        default:
            {
                return state;
            }
    }
}

export default majorReducer;


// WEBPACK FOOTER //
// src/main/content/major/store/reducers/major.reducer.js